module.exports = __webpack_public_path__ + "static/brand07-a9ae8d19c61d9fc29b90c3966c527ca0.png";